import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { useTranslation } from "@coworker/locales";
import { Text } from "../Atoms/Text";

interface StyleGroupProps {
  styleGroup: string;
}

export const StyleGroup = ({ styleGroup }: StyleGroupProps) => {
  const { t } = useTranslation();

  const addonContent = styleGroup ? <Text text={styleGroup} grey /> : "";

  return (
    <FixaListViewItem
      inset
      title={t("styleGroupString")}
      addOn={addonContent}
      emphasised
    />
  );
};
